import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'

import { onClickOutside, useToggle } from '@vueuse/core'
import { computed, ref } from 'vue'

type Option = {
	key: string
	label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleDropdown',
  props: {
    options: null,
    value: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
	options: Option[]
	value: string
};

const optionsContainer = ref(null)



const [opened, toggle] = useToggle(false)



const label = computed(
	() => props.options.find((f) => f.key === props.value)?.label || 'Escolha uma opção',
)

onClickOutside(optionsContainer, () => {
	if (opened) opened.value = false
})

return { __sfc: true,optionsContainer, emit, opened, toggle, props, label, Icon }
}

})